import styled from "styled-components";
import theme from "../../theme";

export const Logo: any = styled.img`
  height: ${(props: any) => props.height};
  margin-bottom: 25px;
  cursor: pointer;
`;
